import { CurrencyCode } from '@rematter/frontend-lib-api-client';

import { AccountBalance } from '../types';

import { toMoney } from '~/modules/trade/utils/money';
import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

type QueryResult = AccountBalance[];

export const balancesQueryAtom = createQueryAtomFactory(
  'finance.balances',
  (params: { searchTerm?: string; currency?: CurrencyCode }) => {
    if (params.searchTerm) {
      return {
        financeAccountsWithBalance: {
          __args: {
            filter: {
              currencies: params.currency ? [params.currency] : undefined,
            },
          },
          id: true,
          pendingTransactions: true,
          balances: {
            amount: true,
            currencyCode: true,
          },
        },
        accounts: {
          __args: {
            filter: { searchTerm: params.searchTerm },
          },
          entries: {
            id: true,
            name: true,
          },
        },
      };
    }

    return {
      financeAccountsWithBalance: {
        __args: {
          filter: {
            currencies: params.currency ? [params.currency] : undefined,
          },
        },
        id: true,
        // If there's no search term passed, we already bring in all information we
        // need about the accounts and save an additional round trip.
        name: true,
        pendingTransactions: true,
        balances: {
          amount: true,
          currencyCode: true,
        },
      },
    };
  },
  {
    select: (data): QueryResult => {
      if (data?.accounts?.entries) {
        const balances = data?.financeAccountsWithBalance || [];
        const accounts = data?.accounts?.entries || [];

        const balanceMap = new Map(balances.map((it) => [it.id, it]));
        return accounts.map((account) => ({
          id: account.id,
          name: account.name,
          pendingTransactions:
            balanceMap.get(account.id)?.pendingTransactions || 0,
          balances:
            balanceMap.get(account.id)?.balances.map((it) => toMoney(it)) || [],
        }));
      }

      return (
        data?.financeAccountsWithBalance?.map((account) => ({
          id: account.id,
          name: account.name,
          pendingTransactions: account.pendingTransactions,
          balances: account.balances.map((it) => toMoney(it)),
        })) || []
      );
    },
  },
);
